import { Component, OnInit, Inject, ViewChild, ElementRef } from '@angular/core';
import { FormGroup, AbstractControl, Validators, FormBuilder } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatSnackBar } from '@angular/material';
import { IHoliday } from 'src/app/interfaces/country';
import { DataService } from 'src/app/services/data.service';
import { pageKey, toDateKey, yearOfDate } from 'src/app/services/mapping.service';
import { statusObj } from 'src/app/dummy/status';
import { List } from 'src/app/stores/administrator/list.store';
import { AuthService } from 'src/app/auth/auth.service';
import { AuthStore } from 'src/app/stores/auth/auth.store';

@Component({
  selector: 'app-add-holiday',
  templateUrl: './add-holiday.component.html',
  styleUrls: ['./add-holiday.component.scss']
})
export class AddHolidayComponent implements OnInit {
  @ViewChild("focus",{static:false}) inputRef:ElementRef;

  form: FormGroup;
  fromDate: AbstractControl;
  toDate:AbstractControl;
  name: AbstractControl;
  description: AbstractControl;


  constructor(
    public dialogRef: MatDialogRef<AddHolidayComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    public store: List,
    public ds: DataService,
        public auth: AuthStore,
    private snackBar: MatSnackBar,
  ) { }

  ngOnInit() {
    this.form = this.fb.group({
      fromDate: [new Date(), Validators.required],
      name: [null, Validators.required],
      toDate:[new Date(),Validators.required],
      description: [null],
    });
    this.fromDate = this.form.controls['fromDate'];
    this.toDate=this.form.controls["toDate"]
    this.name = this.form.controls['name'];
    this.description = this.form.controls['description'];
  }

  create(f: any, isNew: boolean) {
    if(this.form.valid){
      this.form.disable()
      const { fromDate,toDate, name, description } = f;
      const item: IHoliday = {
        key: this.ds.createId(),
        page_key: pageKey(),
        created_date: new Date(),
        created_by: this.ds.collection('users').doc(`${this.auth.user.uid}`).ref,
        isDeleted: false,
        name: name,
        description: description,
        status: statusObj.active,
        fromDate:fromDate,
        toDate:toDate,
        toDateKey:toDateKey(toDate),
        fromDateKey:toDateKey(fromDate),
        year:yearOfDate(fromDate)
      }
      this.store.save(this.ds.holidayRef(), item, (success, res) => {
        if (success) {
          if (!isNew) {
            this.dialogRef.close();
          }
          this.snackBar.open('Holiday has been created.', 'done', { duration: 3000 });
          this.form.reset();
          this.form.enable();
          this.inputRef.nativeElement.focus();
        } else {
          alert(res);
        }
      })
    }
    
  }

}
